import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { UserRepositoryImpl } from "../../domain/userRepositoryImpl/UserRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const userRepo = UserRepositoryImpl.getInstance();

interface UseUserHasPurchaseFunctionReturn {
  readonly hasPurchase: boolean;
  readonly isLoading: boolean;
}

interface UseUserHasPurchaseFunction {
  (): UseUserHasPurchaseFunctionReturn;
}

const useUserHasPurchase: UseUserHasPurchaseFunction = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { data, isLoading } = useQuery(
    {
      queryKey: ["userHasPurchase"],
      queryFn: async () => {
        return await userRepo.hasPurchase(auth, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return {
    hasPurchase: Boolean(data),
    isLoading,
  };
};

export { useUserHasPurchase };
